import { getMarketingConsent, isMarketingPath } from './consent';

/**
 * Conversiones a GA4, espejo de los eventos estándar de Meta Pixel.
 *
 * Solo se envían si gtag ya está cargado (consentimiento + host de producción,
 * ver GoogleAnalytics.tsx) y la ruta actual está en la allowlist de marketing.
 * Nunca se mandan parámetros: tipo de terapia, motivo o datos del paciente son
 * datos de salud sensibles (Ley 19.628 / 21.719).
 */
export type Conversion = 'Contact' | 'Lead' | 'Schedule';

const GA_EVENT: Record<Conversion, string> = {
  Contact: 'contact',
  Lead: 'generate_lead',
  Schedule: 'schedule_appointment',
};

export function trackGaConversion(event: Conversion) {
  try {
    if (!window.gtag) return;
    if (getMarketingConsent() !== 'granted') return;
    if (!isMarketingPath(window.location.pathname)) return;
    window.gtag('event', GA_EVENT[event]);
  } catch {
    // La medición nunca debe romper el flujo de la página.
  }
}
